module.exports = __webpack_public_path__ + "img/logo-eccovia-full-white.9ed72f28.png";